import useResizeResponsive from '@/hooks/useResizeResponsive';
import Box from '../Box/Box';
import { isDesktop } from '@/modules/utils/breakpoints';
import {
  Text,
  TokenTextAppearance,
  TextTag,
  DesignTokenSizeEnum,
} from '@volkswagen-onehub/components-core';
import { HTMLAttributes, ReactNode } from 'react';

interface SectionHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  descriptionSize?: TokenTextAppearance;
  titleBold?: string;
  titleSize?: TokenTextAppearance;
  cta?: ReactNode;
  children?: ReactNode;
  type?: 'lightBold' | 'boldLight';
}

const SectionHeader = ({
  title,
  titleBold,
  description,
  descriptionSize = TokenTextAppearance.copy200,
  children,
  cta,
  titleSize = TokenTextAppearance.headline300,
  type = 'lightBold',
  ...restProps
}: SectionHeaderProps) => {
  const isDesktopWidth = useResizeResponsive(isDesktop);

  return (
    <div {...restProps}>
      <Text tag={TextTag.h2} appearance={titleSize}>
        {type === 'lightBold' ? (
          <>
            {title} {titleBold && <strong> {titleBold}</strong>}
          </>
        ) : (
          <>
            {titleBold && <strong> {titleBold}</strong>} {title}
          </>
        )}
      </Text>
      {(description || (isDesktopWidth && cta)) && (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {description && (
            <Box mt={DesignTokenSizeEnum.static300} b960={{ width: '65%' }}>
              <Text tag={TextTag.p} appearance={descriptionSize}>
                {description}
              </Text>
            </Box>
          )}

          {isDesktopWidth && cta && <div>{cta}</div>}
        </Box>
      )}
      {children}
    </div>
  );
};

export default SectionHeader;
